import { Phone, Mail, MapPin, ArrowRight, ArrowUp } from "lucide-react";
import { BUSINESS } from "@/lib/constants";
import { PhoneChoice } from "@/components/PhoneChoice";

export const Footer = () => {
  return (
    <footer id="contact" data-testid="footer" className="relative bg-ink pt-20 md:pt-28 pb-8 border-t border-surface-2">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="grid lg:grid-cols-2 gap-12 mb-16">
          <div>
            <h2 className="font-display uppercase leading-[0.82] text-5xl md:text-7xl lg:text-[7rem]">
              Let's Sort <br /> Your <span className="text-hazard">Ride.</span>
            </h2>
            <a
              href="#book"
              data-testid="footer-book-btn"
              className="group inline-flex items-center gap-3 mt-10 bg-hazard text-black px-8 py-4 font-mono text-sm tracking-[0.15em] uppercase font-semibold hover:bg-white transition-colors"
            >
              Book Now
              <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
            </a>
          </div>

          <div className="grid sm:grid-cols-2 gap-8">
            <PhoneChoice
              testId="footer-phone"
              align="left"
              className="w-full text-left border border-surface-2 p-6 hover:border-hazard transition-colors group"
            >
              <Phone size={22} className="text-hazard mb-4" />
              <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-zinc-500 mb-2">
                Phone
              </div>
              <div className="font-display text-2xl md:text-3xl tracking-wide group-hover:text-hazard transition-colors">
                {BUSINESS.phone}
              </div>
            </PhoneChoice>
            <a
              href="#book"
              data-testid="footer-email"
              className="border border-surface-2 p-6 hover:border-hazard transition-colors group"
            >
              <Mail size={22} className="text-hazard mb-4" />
              <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-zinc-500 mb-2">
                Email
              </div>
              <div className="font-sans text-sm md:text-base break-all group-hover:text-hazard transition-colors">
                {BUSINESS.email}
              </div>
            </a>
            <div className="border border-surface-2 p-6 sm:col-span-2">
              <MapPin size={22} className="text-hazard mb-4" />
              <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-zinc-500 mb-2">
                Service Area
              </div>
              <div className="font-display text-2xl md:text-3xl tracking-wide">
                {BUSINESS.area}
              </div>
              <div className="text-zinc-500 text-sm mt-1">{BUSINESS.region}</div>
            </div>
          </div>
        </div>

        <div className="hazard-stripes h-3 w-full mb-12" />

        <div className="flex flex-col items-center text-center gap-6">
          <a
            href="#top"
            data-testid="back-to-top"
            aria-label="Back to top of page"
            className="w-14 h-14 rounded-full border border-surface-2 flex items-center justify-center text-hazard hover:bg-hazard hover:text-black transition-colors"
          >
            <ArrowUp size={26} />
          </a>
          <div className="flex items-end gap-2">
            <img src="/warnrs-logo.png?v=2" alt="WARNRS INDUSTRIES PTY LTD" className="h-16 md:h-20 w-auto" />
          </div>
          <div className="font-mono text-xs md:text-sm tracking-[0.2em] uppercase text-zinc-400">
            Mackay QLD &amp; Surrounding Areas
          </div>
          <a
            href="#book"
            data-testid="footer-book-now"
            className="group inline-flex items-center gap-3 bg-hazard text-black px-9 py-4 font-mono text-sm md:text-base tracking-[0.15em] uppercase font-bold hover:bg-white transition-colors"
          >
            Request Booking Now
            <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
          </a>
          <div className="mt-6 flex flex-col sm:flex-row items-center gap-3 text-zinc-500 font-mono text-[11px] tracking-[0.15em] uppercase">
            <span>© {new Date().getFullYear()} {BUSINESS.legal}</span>
            <span className="flex items-center gap-4">
              <a href="/admin/login" data-testid="admin-link" className="hover:text-hazard transition-colors">
                Staff Login
              </a>
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};
